import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { center, stack } from '@flipster/styled-system/patterns';

import heroImage from './hero-image.webp';

export const Hero = () => {
  return (
    <section
      className={stack({
        gap: 16,
        tabletDown: { mt: 32, flexDirection: 'column' },
        tablet: { mt: 64, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
      })}
    >
      <div className={stack({ gap: 24 })}>
        <h1
          className={css({
            textStyle: 'Display/XL',
            color: 'content.default.level-5',
          })}
        >
          <FormattedMessage id='Autogen_common.r251126.s_Dynamic_Earn' />
        </h1>
        <div className={stack({ gap: 4 })}>
          <p
            className={css({
              textStyle: 'Title/L',
              color: 'content.default.level-5',
            })}
          >
            <FormattedMessage id='Earn.r251204.Curated_onchain_earn_title' />
          </p>
          <p
            className={css({
              textStyle: 'Text/L/Regular',
              color: 'content.default.level-3',
            })}
          >
            <FormattedMessage id='Autogen_common.r251126.s_No_wallets_no_gas_no_hassle' />
          </p>
        </div>
      </div>
      <div className={center({ tablet: { px: 100 } })}>
        <img src={heroImage.src} alt='hero' width={200} height={200} />
      </div>
    </section>
  );
};
